import { animated, config, useSpring } from '@react-spring/web';
import React, { useEffect } from 'react';

type SvgButtonProps = {
	Svg: ({ width, height, fill }: { width: number; height: number; fill: string }) => JSX.Element;
	width: number;
	height: number;
	position: 'left' | 'right' | 'topLeft' | 'topRight';
	color: string;
	onClick: () => void;
	enabled: boolean;
};

const SvgButton = ({ Svg, width, height, position, color, onClick, enabled }: SvgButtonProps) => {
	const [animatedStyle, springApi] = useSpring(() => ({ from: { opacity: 0, scale: 0.5 } }), []);
	useEffect(() => {
		springApi.start({ opacity: enabled ? 1 : 0.5, scale: enabled ? 1 : 0.75, config: config.stiff });
	}, [enabled, springApi]);
	return (
		<animated.div
			className="absolute cursor-pointer select-none drop-shadow"
			style={{
				left: position === 'left' ? -1.4 * width : position === 'topLeft' ? 0 : undefined,
				right: position === 'right' ? -1.4 * width : position === 'topRight' ? 0 : undefined,
				top: position.includes('top') ? -1.2 * height : 0,
				...animatedStyle,
			}}
			onClick={enabled ? onClick : () => {}}>
			<Svg width={width} height={height} fill={color} />
		</animated.div>
	);
};

export default SvgButton;
